import { useBoardContext, usePropertyContext } from "@rastreabilidadebrasil/tageditor";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  TextField,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";

import { ArrowsMove, XLg } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

const Image: React.FunctionComponent = () => {
  const { properties, setProperty } = usePropertyContext<fabric.Image>();
  const [keepScale, setKeepScale] = useState<boolean>(true);

  const handleOnChange = (key: string, rawValue: string) => {
    setProperty({ [key]: rawValue });
  };

  const { board } = useBoardContext();

  const closeWindow = () => {
    board?.setActiveObjects();
  };
  const { t } = useTranslation("editor");
  return (
    <>
      <div className="property-bar-title">
        {t("Propriedades do objeto")}
        <ArrowsMove size={20} className="icon left" />
        <IconButton
          onClick={() => closeWindow()}
          className="icon right not-draggable"
        >
          <XLg size={20} color="white" />
        </IconButton>
      </div>
      <Grid container className="tb-main-grid">
        <Grid item md={3}>
          <div className="property-bar-text-itens">
            <span>{t("Opacidade")}</span>
            <TextField
              fullWidth
              className="input-main-width"
              type="number"
              InputProps={{ inputProps: { min: 0, max: 1, step: 0.1 } }}
              value={properties.opacity || 1}
              onChange={(e) => handleOnChange("opacity", e.currentTarget.value)}
              variant="filled"
            />
          </div>

          <div className="property-bar-text-itens extra-bottom-margin">
            <FormGroup>
              <FormControlLabel
                className="editor-numeration-checkbox"
                control={
                  <Checkbox
                    name="checkbox-subtitle"
                    color="primary"
                    checked={keepScale}
                    checkedIcon={<CloseIcon />}
                    onChange={(e) => setKeepScale(e.currentTarget.checked)}
                  />
                }
                label="Manter proporções"
              />
            </FormGroup>
          </div>
        </Grid>
        <Grid item md={3}>
          <div className="property-bar-text-itens">
            <span>{t("Escala de altura")}</span>
            <TextField
              fullWidth
              className="input-main-width"
              type="number"
              InputProps={{ inputProps: { min: 1, max: 100, step: 1 } }}
              value={(properties.scaleY ?? 1) * 100}
              onChange={(e) => {
                const value = (+e.currentTarget.value / 100).toString();

                if (keepScale) {
                  handleOnChange("scaleX", value);
                }
                handleOnChange("scaleY", value);
              }}
              variant="filled"
            />
          </div>
          <div className="property-bar-text-itens">
            <span>{t("Escala de largura")}</span>
            <TextField
              fullWidth
              className="input-main-width"
              type="number"
              InputProps={{ inputProps: { min: 1, max: 100, step: 1 } }}
              value={(properties.scaleX ?? 1) * 100}
              onChange={(e) => {
                const value = (+e.currentTarget.value / 100).toString();

                if (keepScale) {
                  handleOnChange("scaleY", value);
                }
                handleOnChange("scaleX", value);
              }}
              variant="filled"
            />
          </div>
        </Grid>
      </Grid>
    </>
  );
};

export default Image;
